import {
	SegmentedButtons,
	type SegmentedButtonsProps,
} from "react-native-paper";

type Props = SegmentedButtonsProps;

export const ConnectedButtonGroup = (props: Props) => {
	const { buttons, value } = props;

	const selectedValues = Array.isArray(value) ? value : [value];
	const buttonsWithCheck = buttons.map((button) => ({
		...button,
		icon:
			button.icon ??
			(selectedValues.includes(button.value) ? "check" : undefined),
	}));

	return <SegmentedButtons {...props} buttons={buttonsWithCheck} />;
};
